/**
 * Canonical product slug mapping shared by frontend and worker.
 *
 * Products were historically referenced by English slugs (bianstone-*) but
 * are now stored with Chinese slugs. The frontend rewrites legacy slugs to
 * Chinese for links (src/utils/slug.ts); the worker's /api/public/products/:slug
 * endpoint reverse-maps a Chinese slug back to its legacy form when the direct
 * lookup misses, so databases (or CMS fields) using either form keep working.
 */
export const LEGACY_SLUG_MAP: Record<string, string> = {
  'bianstone-pot': '御陽砭石罐【專業版】',
  'bianstone-belt': '御陽近紅外線砭石腰帶',
  'bianstone-mattress': '御陽砭石片&玉石片紅光床塾',
};

/** Returns the legacy English slug for a Chinese display slug, if any. */
export function reverseLegacySlug(displaySlug: string): string | null {
  for (const [legacy, current] of Object.entries(LEGACY_SLUG_MAP)) {
    if (current === displaySlug) return legacy;
  }
  return null;
}
